<template>
  <div @click="toggleFeatures" :style="myBlockProps.getStyles(visible)">
    <a :style="myTextProps.getStyles()">
      <span v-if="myButtonText" >{{ myButtonText.getText(selectedLanguage) }}</span>
    </a>
  </div>
</template>

<script>
import { AllergensButtonProps } from '../../models';
import ButtonBlock from '../ButtonBlock.vue';

export default {
  name: 'link-button-block',
  extends: ButtonBlock,
  props: {
    toggleFeatures: { type: Function, default: () => ({}) }
  },
  computed: {
    myButtonProps() {
      return new AllergensButtonProps(this.buttonProps);
    },
  }
};
</script>

<style scoped>
  a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
